import {useDispatch} from "react-redux";
import React, {useState} from "react";
import {DeleteItemsApi} from "../../../../../reduxToolkit/Commons/CommonsApi";
import {TABLES} from "../../../../../Apis/Tables";
import {errorMsg} from "../../../../../Apis/functions";
import {useTranslation} from "react-i18next";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * @param {boolean} search - Flag to determine if search mode is active.
 * @constructor
 */

export const SuppliersTabApp = ({
    setModified,
    setIsAllChecked,
    setSelectedList
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [option, setOption] = useState(`${TABLES.SUPPLIERS}`);


    const deleteSelectedSuppliers = (deleteItem) => {
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName: option, body })).then(
                ({
                     payload: {
                         data: { success, code},
                     },
                 }) => {
                    if (success === true) {
                        setSelectedList([]);
                        setIsAllChecked(false);
                        setModified(true); // Mark the data as modified
                    }else errorMsg(code)
                },
            );
        }
    };

    return {
        t,
        deleteSelectedSuppliers
    }
}
